var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.062 6.13H3.937A3.265 3.265 0 0 0 .675 9.394v17.27c0 1.8 1.462 3.262 3.262 3.262h28.125c1.8 0 3.263-1.463 3.263-3.263V9.393c0-1.8-1.463-3.262-3.263-3.262Zm0 1.97c.282 0 .507.056.732.225l-14.007 8.493a1.576 1.576 0 0 1-1.575 0L3.206 8.325c.225-.113.45-.225.731-.225h28.125Zm0 19.8H3.937a1.308 1.308 0 0 1-1.293-1.294V10.293l13.5 8.213a3.49 3.49 0 0 0 1.8.506 3.49 3.49 0 0 0 1.8-.506l13.5-8.213v16.313c.112.731-.507 1.294-1.182 1.294Z",
    fill: "#fff"
  })));
};
export default SvgEnvelope;